import { Flex } from "antd";
import {
  EnvironmentOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import Navbar from "../../components/navbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { WelcomeDescription, WelcomeTitle } from "../../styled-components/landing";
import { useQuery } from "@apollo/client";
import { RETRIEVE_RESTAURANTS } from "../../apollo/query/restaurant.query";
import empuriaBrava from '../../assets/empuria-brava.jpg';
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Restaurants = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { data } = useQuery(RETRIEVE_RESTAURANTS);
    const { i18n, t } = useTranslation();
    
    useEffect(() => {
        if( searchParams.get('nIDRestaurant') ) {
            goToRestaurant(parseInt(searchParams.get('nIDRestaurant') as string));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    

    const goToRestaurant = (id: number): void => {
        navigate(`/landing?nIDRestaurant=${id}`);
    }

    return (
        <div
            style={{
                height: '100%',
                width: '100%',
                backgroundColor: '#121212',
                color: 'white',
                backgroundImage:
                `url(${empuriaBrava})`,
                backgroundSize: "cover",
                backgroundAttachment: "fixed",
                backgroundPosition: "center",
                overflowY: 'auto'
            }}
        >
            <Navbar hidden />
            {/* Hero Section */}
            <div style={{ width: '100%', height: '50%', position: 'relative', overflow: 'hidden', paddingTop: 30 }}>
                <div style={{ position: 'absolute', inset: 0, backgroundColor: 'black', opacity: 0.5 }}></div>
                <Flex vertical align='center' justify="center" style={{ position: 'relative', height: '100%', maxWidth: '50%', margin: 'auto', padding: 10, textAlign: 'center' }}>
                    <WelcomeTitle> { t('restaurants.title') } </WelcomeTitle>
                    <WelcomeDescription> { t('restaurants.description') } </WelcomeDescription>
                </Flex>
            </div>
            {/* Restaurant Section */}
            <div style={{ maxWidth: '100%', paddingInline: 30, paddingTop: 10, paddingBottom: 10 }}>
                {/* Restaurant Grid */}
                <Flex align="center" justify="center" gap={20}>
                    {data?.data?.map((restaurant: any) => (
                        <div
                            key={restaurant.nID}
                            onClick={() => goToRestaurant(restaurant.nID)}
                            style={{ backgroundColor: '#1E1E1E', borderRadius: 20, overflow: 'hidden', cursor: 'pointer', maxWidth: 500, boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px' }}>
                            <div style={{ height: 200, overflow: 'hidden' }}>
                            <img
                                src={restaurant.sLogo}
                                alt={restaurant.sName}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                            </div>
                            <div style={{ padding: 20 }}>
                                <h3 style={{ fontSize: '3rem', fontFamily: 'Suburban', margin: 0 }}>{restaurant.sName}</h3>
                                <p style={{ fontSize: '0.9rem', color: 'white', marginBottom: 10, fontFamily: 'Roboto-Thin' }}> { restaurant.languages[`cuisine-${i18n.language}`] } </p>
                                <p style={{ color: 'white', marginBottom: 10, lineHeight: 2 }}> { restaurant.languages[`desc-${i18n.language}`] } </p>
                                <Flex gap={20} align="center" style={{ color: 'white', fontSize: '0.9rem', marginBottom: 10, paddingTop: 20 }}>
                                    <ClockCircleOutlined />
                                    <span>{restaurant.sHours}</span>
                                </Flex>
                                <Flex gap={20} align="center" style={{ color: 'white', fontSize: '0.9rem', marginBottom: 10 }}>
                                    <EnvironmentOutlined />
                                    <span>{restaurant.sAddress}</span>
                                </Flex>
                            </div>
                        </div>
                    ))}
                </Flex>
            </div>
        </div>
    );
};

export default Restaurants;
